module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('settings.setting_label'),
      "icon": "icon-gearwheels",
      "colWidth": "6"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "contactButtonContainer mt-0 mb-4",
    staticStyle: {
      "background-color": "var(--headbandColor)",
      "box-shadow": "rgba(0,0,0,0.5) 0 0 10px !important"
    }
  }, [_c('b-row', {
    staticClass: "no-gutters justify-content-start"
  }, [_c('b-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "sm": "4"
    }
  }, [(_vm.currentTab === 'DP') ? _c('f7-link', {
    staticClass: "pilotageLink tabActive",
    attrs: {
      "tab-link": ".membersTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('DP')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.dir_pymnts')))]) : _c('f7-link', {
    staticClass: "pilotageLink tabUnactive",
    attrs: {
      "tab-link": ".membersTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('DP')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.dir_pymnts')))])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "sm": "4"
    }
  }, [(_vm.currentTab === 'RTP') ? _c('f7-link', {
    staticClass: "pilotageLink tabActive",
    attrs: {
      "tab-link": ".membersTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('RTP')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.req_to_py')))]) : _c('f7-link', {
    staticClass: "pilotageLink tabUnactive",
    attrs: {
      "tab-link": ".membersTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('RTP')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.req_to_py')))])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "sm": "4"
    }
  }, [(_vm.currentTab === 'ML') ? _c('f7-link', {
    staticClass: "pilotageLink tabActive",
    attrs: {
      "tab-link": ".membersTab3"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('ML')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.mod_cred')))]) : _c('f7-link', {
    staticClass: "pilotageLink tabUnactive",
    attrs: {
      "tab-link": ".membersTab3"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('ML')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.mod_cred')))])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "sm": "4"
    }
  }, [(_vm.currentTab === 'DS') ? _c('f7-link', {
    staticClass: "pilotageLink tabActive",
    attrs: {
      "tab-link": ".membersTab4"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('DS')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.business_docs')))]) : _c('f7-link', {
    staticClass: "pilotageLink tabUnactive",
    attrs: {
      "tab-link": ".membersTab4"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('DS')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.business_docs')))])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "sm": "4"
    }
  }, [(_vm.currentTab === 'MP') ? _c('f7-link', {
    staticClass: "pilotageLink tabActive",
    attrs: {
      "tab-link": ".membersTab5"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('MP')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.marketplace')))]) : _c('f7-link', {
    staticClass: "pilotageLink tabUnactive",
    attrs: {
      "tab-link": ".membersTab5"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('MP')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('servicesNames.marketplace')))])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentTab === 'DP') ? _c('dp-settings', {
    attrs: {
      "settings": _vm.DPSettingsData
    }
  }) : (_vm.currentTab === 'RTP') ? _c('rtp-settings', {
    attrs: {
      "settings": _vm.RTPSettingsData
    }
  }) : (_vm.currentTab === 'ML') ? _c('ml-settings', {
    attrs: {
      "settings": _vm.MLSettingsData
    }
  }) : (_vm.currentTab === 'DS') ? _c('ds-settings', {
    attrs: {
      "settings": _vm.DSSettingsData
    }
  }) : (_vm.currentTab === 'MP') ? _c('mp-settings', {
    attrs: {
      "settings": _vm.MPSettingsData
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "2",
      "offset-md": "7"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.changeApplicationSettings
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "save"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.sve')))])], 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-390e4f49", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390e4f49","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/CMApplicationSettingsPage.vue
// module id = 2333
// module chunks = 2